<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView_CheckVouch">
			<div class="BottomTable">
				<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="新增" fontSize="14px"
					@btnclick="handleAdd" :src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
				<Commonbtn v-if="auth.includes('edit') && !cusCode" backgroundColor="#FFF" title="修改" fontSize="14px"
					:useAutoOptional="false" :optional="selectIds.length !== 1"
					@btnclick="handleEditTask" :src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<Commonbtn v-if="auth.includes('delete')" backgroundColor="#FFF" title="删除" fontSize="14px"
					:useAutoOptional="false" :optional="selectIds.length !== 1"
					@btnclick="handleDel" :src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<Commonbtn v-if="auth.includes('approval')" backgroundColor="#FFF" opwidth="72px" top="370px"
					:src="require('@/assets/icon/icon-update.png')" title="确认" fontSize="14px"
					:useAutoOptional="false" :optional="selectIds.length !== 1" @btnclick="handConfirm">
				</Commonbtn>
				<Commonbtn v-if="auth.includes('approval')" backgroundColor="#FFF" title="驳回" fontSize="14px"
					:useAutoOptional="false" :optional="selectIds.length !== 1"
					@btnclick="handReject" :src="require('@/assets/icon/hospital-two.png')">
				</Commonbtn>
				<Commonbtn v-if="auth.includes('revoke')" backgroundColor="#FFF" title="弃审" fontSize="14px"
					:useAutoOptional="false" :optional="selectIds.length !== 1"
					@btnclick="handRevoke" :src="require('@/assets/icon/hospital-two.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="指导视频" fontSize="14px" @btnclick="dialogVisibVideo = true"
					:src="require('@/assets/icon/video.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="勾选导出" fontSize="14px" @btnclick="handButton(8)"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
				<!-- 
				<Commonbtn backgroundColor="#FFF" title="撤回" fontSize="14px" @btnclick="handButton(5)"
					:src="require('@/assets/icon/hospital-two.png')">
				</Commonbtn> -->
				<!-- <Commonbtn backgroundColor="#FFF" title="清空" fontSize="14px" @btnclick="handButton(6)"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn> -->
				<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
					@click="handButton(7)">下载导入模版</a>
			</div>
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData" style="width: 100%;" highlight-current-row
					@current-change="currentRow" @selection-change="(e)=>selectIds = e" @cell-dblclick="handleCellDblclick">
					<el-table-column type="selection" width="55" fixed="left" />
					<el-table-column prop="StatusName" label="状态" width="80" show-overflow-tooltip />
					<el-table-column prop="CVCode" label="单据号" width="120" show-overflow-tooltip />
					<el-table-column prop="CVTitle" label="任务名称" width="250" show-overflow-tooltip />
					<el-table-column prop="CreateOrgName" label="经销商" width="250" show-overflow-tooltip />
					<el-table-column prop="InvClassName" label="产品线" width="100" show-overflow-tooltip />
					<el-table-column prop="CreateTime" label="创建时间" width="170" show-overflow-tooltip />
					<el-table-column prop="UpdateTime" label="修改日期" width="170" show-overflow-tooltip />
					<el-table-column prop="RejectTime" label="驳回时间" width="170" show-overflow-tooltip />
					<el-table-column prop="VerifyTime" label="审核时间" width="170" show-overflow-tooltip />
					<el-table-column prop="RejectReason" label="驳回原因" width="170" show-overflow-tooltip />
					<el-table-column label="留言状态">
						<template slot-scope="scope">
							<span class="table-export" @click="scope.row.HasNewMessage ? handShowChat(scope.row) : null"
								:style="{color:!scope.row.HasNewMessage?'#cccccc':'', cursor: !scope.row.HasNewMessage ? 'default' : 'pointer'}">{{scope.row.HasNewMessage?'未读':'已读'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="Remark" label="备注" width="200" show-overflow-tooltip />
					<el-table-column width="160" label="导出操作" fixed="right">
						<template slot-scope="scope">
							<span class="table-export" @click="handExport(scope.row)">对账结果</span> 
							<span class="table-export" @click="handExportDtl(scope.row)">明细</span> 
							<span class="table-export" @click="handShowChat(scope.row)">留言</span> 
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
			<div class="incenters TableBox" v-if="tableCurr">
				<div class="topstate" :class="[currTabs ===index?'ativte':'']" v-for="(item,index) in tabsArr"
					:key="index" @click="handCurrTabs(index)">
					{{item}}
				</div>
				<CommonbtnUpLoad backgroundColor="#FFF" title="导入库存" fontSize="14px" @getFile="handImport"
					:src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<CommonbtnUpLoad v-if="!cusCode" backgroundColor="#FFF" title="补充导入" fontSize="14px"
					@getFile="handImport2" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
			</div>
			<Commonbtn backgroundColor="#FFF" :useAutoOptional="false" v-if="!isUpdate&&tableCurr&&currTabs===0"
				:optional="tableCurr.StatusName=='新增'||tableCurr.StatusName=='已驳回'?false:true" opwidth="72px"
				top="370px" :src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px"
				@btnclick="isUpdate = true">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="isUpdate&&currTabs===0" title="保存" fontSize="14px" @btnclick="handUpdate"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="isUpdate&&currTabs===0" title="取消" fontSize="14px" @btnclick="isUpdate = false"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :useAutoOptional="false" v-if="tableCurr&&currTabs===1"
				:optional="tableCurr.StatusName=='新增'||tableCurr.StatusName=='已驳回'?false:true" opwidth="72px"
				top="370px" :src="require('@/assets/icon/icon-del.png')" title="删除" fontSize="14px"
				@btnclick="handDelUnique">
			</Commonbtn>
			<!--明细-->
			<div class="custom-table" v-if="tableCurr">
				<FromComm :FromArr="FromArrs"></FromComm>
				<div class="btngroup" style="transform: translateY(-40px);">
					<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch2" @reset="handReset2" />
				</div>
				<el-table v-if="!currTabs" key="table1" :data="tableData2" style="width: 100%;" @cell-dblclick="handleCellDblclick">
					<el-table-column prop="WHName" label="仓库" width="150" />
					<el-table-column prop="InvAddCode" label="商品代码" />
					<el-table-column prop="InvName" label="商品名称" />
					<el-table-column prop="Batch" label="批号" />
					<el-table-column prop="ValiDate" label="有效期至">
						<template slot-scope="scope">
							{{scope.row.ValiDate?scope.row.ValiDate.substring(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column prop="DiffQuantity" label="调整数量" width="120" />
					<el-table-column prop="Quantity" label="导入库存" width="120">
						<template slot-scope="scope">
							<template v-if="isUpdate&&scope.row.InvAddCode!='合计'">
								<el-input class="update_ipt" v-model="scope.row.Quantity" placeholder="输入数量" />
							</template>
							<template v-else>
								{{scope.row.Quantity}}
							</template>
						</template>
					</el-table-column>
					<el-table-column prop="UsedQuantity" label="鸿雁库存" width="120" />
				</el-table>
				<el-table v-else key="table2" :data="tableData2" style="width: 100%;" @selection-change="(e)=>selectUniqueIds = e" @cell-dblclick="handleCellDblclick">
					<el-table-column type="selection" width="55" />
					<el-table-column prop="WHName" label="仓库" width="150" />
					<el-table-column prop="InvAddCode" label="商品代码" />
					<el-table-column prop="InvName" label="商品名称" />
					<el-table-column prop="Batch" label="批号" />
					<el-table-column prop="ValiDate" label="有效期至">
						<template slot-scope="scope">
							{{scope.row.ValiDate?scope.row.ValiDate.substring(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column prop="Quantity" label="数量" width="120" />
					<el-table-column prop="InvUniqueCode" label="唯一码" width="120" />
				</el-table>
			</div>
			<div class="pagination" v-if="tableCurr">
				<Pagination ref="invPagination" type='allColor' :pageSize="query2.pageSize"
					@handleCurrentChange="handleCurrentChange2" @handleSizeChange="handleSizeChange2" :total="total2">
				</Pagination>
			</div>
		</div>
		<DialogFrom width="890px" title="库存对账指导视频" :OKASCAN="false" :dialogVisible="dialogVisibVideo"
			@cancel="dialogVisibVideo = false" @dialogOK="dialogVisibVideo = false">
			<VideoPlayer ref="outbouVideo" v-if="dialogVisibVideo"
				:srcVideo="require('../../../../assets/video/inventory/inventory.mp4')">
			</VideoPlayer>
		</DialogFrom>

		<DialogFrom width="1000px" title="调整数量" :OKASCAN="false" :dialogVisible="dialogNumVisible" @cancel="numCancel">
			<div class="custom-table" v-if="tableNumList.length">
				<FromComm :FromArr="FromArr2" @selectChange="handInvClass"></FromComm>
				<Commonbtn backgroundColor="#FFF" title="确认" fontSize="14px" @btnclick="VerifyCheckData(tableNumList)"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<Commonbtn style="margin-left:12px;" backgroundColor="#FFF" title="直接确认" fontSize="14px"
					@btnclick="VerifyCheckData()" :src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<el-table ref="tabNum" :data="tableNumList" style="width: 100%;" height="450"
					@selection-change="(e)=>selectNumIds = e" @cell-dblclick="handleCellDblclick">
					<el-table-column type="selection" width="55" />
					<el-table-column prop="WHName" label="仓库" />
					<el-table-column prop="InvAddCode" label="商品代码" width="150" />
					<el-table-column prop="InvName" label="商品名称" />
					<el-table-column prop="Batch" label="批号" />
					<el-table-column prop="ValiDate" label="有效期至">
						<template slot-scope="scope">
							{{scope.row.ValiDate?scope.row.ValiDate.substring(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column prop="DiffQuantity" label="调整数量" w>
						<template slot-scope="scope">
							<el-input class="update_ipt" v-model="scope.row.DiffQuantity" placeholder="输入数量" />
						</template>
					</el-table-column>
					<el-table-column prop="Quantity" label="导入库存" />
					<el-table-column prop="UsedQuantity" label="鸿雁库存" />
				</el-table>
			</div>
		</DialogFrom>

		<DialogFrom width="750px" :title="dialogType === 'add' ? '新增盘点任务' : '修改盘点任务'" :dialogVisible="dialogVisible" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist v-show="!item.hidden" :key="index" ref="adds" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color" :disabled="item.disabled"
						:radiotitle1="item.radiotitle1" :widths="item.widths" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :options="item.options" :width="item.width"
						@remoteMethodtows="remoteMethod" />
				</template>
			</div>
		</DialogFrom>
		<!--留言-->
		<DialogFrom width="1000px" title="留言" rigthText="提交" :dialogOKFlag="tabNames=='second'?true:false"
			:dialogVisible="dialogVisChat" @cancel="cancelChat" @dialogOK="dialogChat">
			<div class="from">
				<el-tabs v-model="tabNames" type="card">
					<el-tab-pane label="查看留言" name="first">
						<div class="chat-container" ref="chatContainer">
							<div v-for="(message, index) in dialogMsg" :key="index" class="message"
								:class="[message.IsSelf === 1 ? 'rights' : 'lefts']">
								<!-- 他人消息 -->
								<template v-if="message.IsSelf == 0">
									<img src="../../../../assets/icon/his-ico.png" class="avatar" alt="avatar">
									<div class="content-box">
										<div class="info">
											<span class="nickname">{{ message.CreatorName }}</span>
											<span class="time">{{ message.CreateTime }}</span>
										</div>
										<div class="bubble other">{{ message.Message }}</div>
									</div>
								</template>

								<!-- 我的消息 -->
								<template v-else>
									<div class="content-box me">
										<div class="info">
											<span class="time" style="margin-right:8px">{{ message.CreateTime }}</span>
											<span class="nickname">{{ message.CreatorName }}</span>
										</div>
										<div class="bubble me">{{ message.Message }}</div>
									</div>
									<img src="../../../../assets/icon/my-ico.png" class="avatar" alt="avatar">
								</template>
							</div>
						</div>

					</el-tab-pane>
					<el-tab-pane label="发布留言" name="second">
						<el-input style="margin-top:12px;" type="textarea" :rows="4" placeholder="请输入留言内容"
							v-model="textChat" />
					</el-tab-pane>
				</el-tabs>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import Commontable from '../../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import utils from '../../../../common/utils'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import fromdata from './FormData/add'
	import VideoPlayer from '../../../../components/videoPlayer.vue'
	import {
		GetHelperOrderStatus,
		GetCheckVouchDataList,
		VerifyCheckVouch,
		UnVerifyCheckVouch,
		RejectCheckVouch,
		GetCheckVouchList,
		ExportCheckVouch,
		AddScanCheckVouch,
		GetUniqueDetail,
		GetWarehouseForCheckVouch,
		DownloadTempletCheckVouch,
		ImportCheckVouch,
		EditCheckVouch,
		SubmitCheckVouch,
		CancelCheckVouch,
		DeleteCheckVouch,
		GetCustomerList,
		DetailExportCheckVouch,
		ImportReplenish,
		GetMessageCheckVouch,
		AddMessageCheckVouch,
		ReadBoardCheckVouch,
		GetCheckVouchInvNamesList,
		EditCheckVouchTitle,
		DelUniqueCheckVouch
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			CommonbtnUpLoad,
			Commontable,
			DialogFrom,
			Commondropdownlist,
			VideoPlayer
		},
		computed: {
			cusCode() {
				return this.$store.state.MenusData.CusCode;
			}
		},
		data() {
			return {
				tableNumList: [],
				dialogNumVisible: false,
				selectIds: [],
				selectUniqueIds: [],
				currTabs: 0,
				tabsArr: ['明细', '唯一码明细'],
				FromArr2: [{
					title: "产品名称：",
					inputtype: "select",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					lableheight: 20,
					X: false,
					types: "",
					placeholder: "请选择",
					width: 220,
					height: 32,
					disabled: false,
					marginLeft: 6,
					marginTop: 0,
					displayVal: "inline-block",
					fontWeightVal: 500,
					options: [],
					multiple: true,
					collapseTags: true,
					event: "invClass",
				}],
				FromArrs: [{
						title: "仓库：",
						inputtype: "select",
						inputflag: true,
						fontSize: 14,
						color: "#333333",
						lableheight: 20,
						X: false,
						types: "",
						placeholder: "请选择",
						width: 180,
						height: 32,
						disabled: false,
						marginLeft: 24,
						marginTop: 28,
						displayVal: "inline-block",
						fontWeightVal: 500,
						options: []
					}, {
						title: "产品型号/名称：",
						inputtype: "input",
						inputflag: true,
						fontSize: 14,
						color: "#333333",
						lableheight: 20,
						X: false,
						types: "",
						placeholder: "请输入",
						width: 180,
						height: 32,
						disabled: false,
						marginLeft: 24,
						marginTop: 20,
						displayVal: "inline-block",
						fontWeightVal: 500
					}, {
						title: "批号：",
						inputtype: "input",
						inputflag: true,
						fontSize: 14,
						color: "#333333",
						lableheight: 20,
						X: false,
						types: "",
						placeholder: "请输入",
						width: 180,
						height: 32,
						disabled: false,
						marginLeft: 24,
						marginTop: 20,
						displayVal: "inline-block",
						fontWeightVal: 500
					},
					{
						title: "只看差异：",
						inputtype: "checkedD",
						inputflag: true,
						fontSize: 14,
						color: "#333333",
						lableheight: 20,
						X: false,
						types: "",
						width: 200,
						height: 32,
						disabled: false,
						marginLeft: 30,
						marginTop: 32,
						displayVal: "inline-block",
						fontWeightVal: 500,
						checked: false,
						hidden: false,
					}
				],
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				query2: {
					pageIndex: 1,
					pageSize: 10
				},
				total2: 0,
				isUpdate: false,
				FromArr: [],
				tableCurr: null,
				tableData: [],
				tableData2: [],
				fromdataadd: [],
				dialogVisible: false,
				dialogType: 'add',
				isUpdate: false,
				dialogVisChat: false,
				dialogMsg: [], //留言信息
				cvmid: '',
				tabNames: 'first',
				textChat: '',
				dialogVisibVideo: false,
				selectNumIds: [],
			}
		},
		mounted() {
			console.log(111, this.auth, this.cusCode)
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			if (this.cusCode) {
				this.fromdataadd[1].hidden = true;
				this.fromdataadd[2].hidden = true;
				this.fromdataadd[3].hidden = true;
			}
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.getData();
			this.GetHelperOrderStatus();
			this.InventoryClassList();
		},
		methods: {
			handleCellDblclick(row, column, cell, event) {
				let text = '';
				if (column.property && row[column.property] !== undefined && row[column.property] !== null) {
					text = String(row[column.property]);
				} else {
					text = cell.innerText ? cell.innerText.trim() : '';
				}
				if (text) {
					const textarea = document.createElement('textarea');
					textarea.value = text;
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand('copy');
					document.body.removeChild(textarea);
					this.$message.success('复制成功');
				}
			},
			handInvClass() {
				this.tableNumList.forEach(it => {
					this.$refs.tabNum.toggleRowSelection(it, false);
				})
				this.FromArr2[0].modelvalue.forEach(it => {
					const indexs = this.tableNumList.reduce((acc, item, index) => {
						if (item.InvName === it) {
							acc.push(index);
						}
						return acc;
					}, []);

					indexs.forEach(ip => {
						this.$refs.tabNum.toggleRowSelection(this.tableNumList[ip], true);
					})
				})
			},
			async getInvNamesList() {
				let {
					code,
					data,
					message
				} = await GetCheckVouchInvNamesList({
					CVMID: this.tableCurr ? this.tableCurr.CVMID : '',
				})
				if (code == 0) {
					this.FromArr2[0].options = data.map(it => {
						it.key = it.Text;
						it.value = it.Value;
						return it;
					});
				} else {
					this.$message.error(message);
				}
			},
			//将对话置底
			scrollToBottom() {
				this.$nextTick(() => {
					const container = this.$refs.chatContainer
					if (container) {
						// 使用动画平滑滚动
						// container.scrollTo({
						// 	top: container.scrollHeight,
						// 	behavior: 'smooth'
						// })
						// 或者直接跳转（无动画）
						container.scrollTop = container.scrollHeight
					}
				})
			},
			async handShowChat(e) {
				let res = await ReadBoardCheckVouch({
					CVMID: e.CVMID
				})
				if (!res.code) {
					this.getData();
				} else {
					this.$message.error(res.message);
				}
				this.getMessage(e);
			},
			async getMessage(e) {
				let {
					code,
					data,
					message
				} = await GetMessageCheckVouch({
					CVMID: e.CVMID
				})
				if (code == 0) {
					this.dialogVisChat = true;
					this.cvmid = e.CVMID;
					if (data && data.data.length) {
						this.dialogMsg = data.data.reverse();
						this.scrollToBottom();
					}
				} else {
					this.$message.error(message);
				}
			},
			cancelChat() {
				this.cvmid = '';
				this.dialogMsg = [];
				this.tabNames = 'first';
				this.textChat = '';
				this.dialogVisChat = false;
			},
			async dialogChat() {
				if (!this.textChat) {
					this.$message.error('请输入留言内容');
					return;
				}
				let {
					code,
					data,
					message
				} = await AddMessageCheckVouch({
					CVMID: this.cvmid,
					Message: this.textChat
				})
				if (code == 0) {
					this.tabNames = 'first';
					this.getMessage({
						CVMID: this.cvmid
					});
					this.textChat = '';
					this.$message.success('发布成功！');
				} else {
					this.$message.error(message);
				}
			},
			//查询列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.Status = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.Customer = this.FromArr[2].modelvalue;
				this.query.SubmitTime1 = this.FromArr[3].StartTime;
				this.query.SubmitTime2 = this.FromArr[3].EndTime;
				this.query.VerifyTime1 = this.FromArr[4].StartTime;
				this.query.VerifyTime2 = this.FromArr[4].EndTime;
				this.query.CVTitle = this.FromArr[5].modelvalue;
				this.query.HasUnViewMessage = this.FromArr[6].checked ? 1 : 0;
				let {
					code,
					data,
					message
				} = await GetCheckVouchDataList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
					loading.close();
				} else {
					loading.close();
					this.$message.error(message);
				}
			},
			//修改数据
			async handUpdate() {
				let params = [];
				this.tableData2.forEach(item => {
					if (item.CVDID) {
						params.push({
							CVDID: item.CVDID,
							Quantity: item.Quantity ? item.Quantity : 0
						})
					}
				})
				let res = await EditCheckVouch(params, this.tableCurr.CVMID)
				if (res.code == 0) {
					this.query2.pageIndex = 1;
					this.getDetail();
					this.isUpdate = false;
					this.$message.success('提交成功');
				} else {
					this.$message.error(res.message);
				}
			},
			async handDelUnique() {
				if (!this.selectUniqueIds || !this.selectUniqueIds.length) {
					this.$message.warning('请勾选需要删除的唯一码明细');
					return;
				}
				this.$confirm('确定要删除勾选的唯一码明细吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let cvduiDs = this.selectUniqueIds.map(item => item.CVDUID);
					let res = await DelUniqueCheckVouch({
						cvmid: this.tableCurr.CVMID,
						cvduiDs: cvduiDs
					});
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.query2.pageIndex = 1;
						this.getDetail();
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {});
			},
			//仓库下拉列表
			async GetWarehouseForCheckVouch() {
				let {
					code,
					data
				} = await GetWarehouseForCheckVouch({
					CVMID: this.tableCurr.CVMID
				})
				if (code == 0) {
					this.FromArrs[0].options = []
					data.map((item, index) => {
						this.FromArrs[0].options.push({
							key: item.WHCode,
							value: item.WHName
						})
					})
				}
			},
			//状态下拉
			async GetHelperOrderStatus() {
				let {
					code,
					data
				} = await GetHelperOrderStatus({})
				if (code == 0) {
					this.FromArr[0].options = []
					data.map((item, index) => {
						this.FromArr[0].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			// 产品线下拉
			async InventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.fromdataadd[0].options = []
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						};
						this.fromdataadd[0].options.push(obj)
						this.FromArr[1].options.push(obj)
					})
				}
			},
			//导入数据
			async handImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ImportCheckVouch(formdata, this.cusCode, this.tableCurr.CVMID)
				if (code == 0) {
					this.query2.pageIndex = 1;
					this.$message.success('导入成功');
					this.getDetail();
				} else {
					if (data && data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			//补充数据
			async handImport2(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ImportReplenish(formdata, this.cusCode, this.tableCurr.CVMID)
				if (code == 0) {
					this.query2.pageIndex = 1;
					this.$message.success('导入成功');
					this.getDetail();
				} else {
					if (data && data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			handCurrTabs(e) {
				this.currTabs = e;
				this.query2.pageIndex = 1;
				this.getDetail();
			},
			//查询明细
			async getDetail() {
				let params = {
					CVMID: this.tableCurr ? this.tableCurr.CVMID : '',
					pageIndex: this.query2.pageIndex,
					pageSize: this.query2.pageSize,
				}
				params.WHCode = this.FromArrs[0].modelvalue;
				params.Inventory = this.FromArrs[1].modelvalue;
				params.Batch = this.FromArrs[2].modelvalue;
				if (this.FromArrs[3].checked) {
					params.OnlyDiff = 1;
				}
				if (this.currTabs) {
					let {
						code,
						data,
						message
					} = await GetUniqueDetail(params);
					if (code == 0) {
						this.total2 = data.Count;
						this.tableData2 = data.data;
					} else {
						this.$message.error(message);
					}
				} else {
					let {
						code,
						data,
						message
					} = await GetCheckVouchList(params);
					if (code == 0) {
						this.total2 = data.Count;
						this.tableData2 = data.data;
					} else {
						this.$message.error(message);
					}
				}
			},
			//触发当前行
			currentRow(e) {
				if (e) {
					this.tableCurr = e;
					this.query2.pageIndex = 1;
					this.isUpdate = false;
					this.getDetail();
					this.GetWarehouseForCheckVouch();
				}
			},
			//获取单选勾选数据（确认/驳回/删除统一校验）
			getSingleSelectedRow(actionName) {
				if (this.selectIds.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}`);
					return null;
				}
				return this.selectIds[0];
			},
			//确认
			handConfirm() {
				const row = this.getSingleSelectedRow('确认');
				if (!row) return;
				this.tableCurr = row;
				this.$confirm('确认提交?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let {
						code,
						data,
						message
					} = await GetCheckVouchList({
						CVMID: this.tableCurr ? this.tableCurr.CVMID : '',
						OnlyDiff: 1,
						NoSummary: 1,
						pageIndex: 1,
						pageSize: 999,
					});
					if (code == 0) {
						if (data.data.length) {
							this.tableNumList = data.data;
							this.dialogNumVisible = true;
							this.getInvNamesList();
						} else {
							this.VerifyCheckData();
						}
					} else {
						this.$message.error(message);
					}
				}).catch(() => {});
			},
			//确认
			VerifyCheckData(list = []) {
				let params = {
					CVMID: this.tableCurr.CVMID
				}
				//如果有list 则代表 确认
				if (list.length) {
					let arr = [];
					if (!this.selectNumIds.length) {
						this.$confirm('当前未勾选任何明细，将不会生成库存调整单，确认提交？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.updateData(params);
						}).catch(() => {});
					} else {
						this.selectNumIds.forEach(it => {
							arr.push({
								cvdid: it.CVDID,
								adjustQuantity: it.DiffQuantity,
							})
						})
						params.AdjustDetails = arr;
						this.updateData(params);
					}
				} else {
					//直接确认
					if (this.selectNumIds.length) {
						this.$confirm('当前有勾选调整内容，是否不生成库存调整单直接确认？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.updateData(params);
						}).catch(() => {});
					} else {
						this.updateData(params);
					}
				}
			},
			async updateData(params) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await VerifyCheckVouch(params);
				loading.close();
				if (code == 0) {
					this.numCancel();
					this.getData();
					this.$message.success('操作成功');
					this.$refs.tableRef.setCurrentRow('')
				} else {
					this.$message.error(message);
				}
			},
			//取消
			numCancel() {
				this.tableNumList = [];
				this.dialogNumVisible = false;
			},
			//驳回
			handReject() {
				const row = this.getSingleSelectedRow('驳回');
				if (!row) return;
				this.tableCurr = row;
				this.$prompt('请输入驳回原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(async ({
					value
				}) => {
					let {
						code,
						message,
						data
					} = await RejectCheckVouch({
						CVMID: this.tableCurr.CVMID,
						Reason: value
					})
					if (code == 0) {
						this.getData();
						this.$message.success('操作成功');
						this.$refs.tableRef.setCurrentRow('')
					} else {
						this.$message.error(message);
					}
				}).catch(() => {});
			},
			//弃审
			handRevoke() {
				const row = this.getSingleSelectedRow('弃审');
				if (!row) return;
				this.tableCurr = row;
				this.$confirm('确定要弃审吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let {
						code,
						message,
						data
					} = await UnVerifyCheckVouch({
						CVMID: this.tableCurr.CVMID
					})
					if (code == 0) {
						this.getData();
						this.$message.success('操作成功');
						this.$refs.tableRef.setCurrentRow('')
					} else {
						this.$message.error(message);
					}
				}).catch(() => {});
			},
			async handButton(t) {
				switch (t) {
					case 4: //提交
						if (!this.tableCurr) {
							this.$message.error('未选择数据');
							return
						}
						this.$confirm('是否提交?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(async () => {
							let res1 = await SubmitCheckVouch({
								CVMID: this.tableCurr.CVMID,
							}, this.cusCode)
							if (res1.code == 0) {
								this.getData();
								this.$message.success('操作成功');
							} else {
								this.$message.error(res1.message);
							}
						}).catch(() => {});
						break;
					case 5: //撤回
						if (!this.tableCurr) {
							this.$message.error('未选择数据');
							return
						}
						this.$confirm('是否撤回?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(async () => {
							let res2 = await CancelCheckVouch({
								CVMID: this.tableCurr.CVMID,
							}, this.cusCode)
							if (res2.code == 0) {
								this.getData();
								this.$message.success('操作成功');
							} else {
								this.$message.error(res2.message);
							}
						}).catch(() => {});
						break;
					case 6: //清空
						if (!this.tableCurr) {
							this.$message.error('未选择数据');
							return
						}
						this.$confirm('是否清空?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(async () => {
							let res3 = await DeleteCheckVouch({
								CVMID: this.tableCurr.CVMID,
							}, this.cusCode)
							if (res3.code == 0) {
								this.getData();
								this.$message.success('操作成功');
							} else {
								this.$message.error(res3.message);
							}
						}).catch((e) => {
							console.log(e)
						});
						break;
					case 7: //下载
						let {
							data,
							code,
							message
						} = await DownloadTempletCheckVouch({})
						if (code == 0) {
							window.location.href = data
						} else {
							this.$message.error(message);
						}
						break;
					case 8: //提交
						if (!this.selectIds.length) {
							this.$message.error('未选择数据');
							return
						}
						let resexprot = await DetailExportCheckVouch({
							CVMID: this.selectIds.map(it => it.CVMID).join(',')
						})
						if (resexprot) {
							let date = new Date()
							let str =
								`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
							utils.downloadFile(resexprot, `「库存明细」${str}`, "xlsx")
							this.$refs.tableRef.clearSelection();
						} else {
							// 返回json
							this.$message.warning('导出失败');
						}
						break;
				}
			},
			//对账结果
			async handExport(e) {
				let params = {
					CVMID: e.CVMID
				}
				params.WHCode = this.FromArrs[0].modelvalue;
				params.Inventory = this.FromArrs[1].modelvalue;
				params.Batch = this.FromArrs[2].modelvalue;
				if (this.FromArrs[3].checked) {
					params.OnlyDiff = 1;
				}
				let resexprot = await ExportCheckVouch(params);
				if (resexprot) {
					let date = new Date()
					let str =
						`${e.CreateOrgName}-${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `「对账结果」${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			//明细导出
			async handExportDtl(e) {
				let resexprot = await DetailExportCheckVouch({
					CVMID: e.CVMID
				})
				if (resexprot) {
					let date = new Date()
					let str =
						`${e.CreateOrgName}-${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `「库存明细」${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
					item.StartTime = '';
					item.EndTime = '';
					item.checked = false;
				})
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			handleAdd() {
				this.dialogType = 'add';
				this.fromdataadd.forEach(item => {
					item.inputdata = '';
					item.disabled = false;
					item.hidden = false;
				});
				if (this.cusCode) {
					this.fromdataadd[1].hidden = true;
					this.fromdataadd[2].hidden = true;
					this.fromdataadd[3].hidden = true;
				}
				this.dialogVisible = true;
			},
			handleEditTask() {
				if (this.selectIds.length !== 1) {
					this.$message.warning('请选择一条数据进行修改');
					return;
				}
				this.dialogType = 'edit';
				let row = this.selectIds[0];
				
				this.fromdataadd.forEach(item => {
					item.inputdata = '';
					item.disabled = false;
					item.hidden = false;
				});
				
				// 产品线禁用
				this.fromdataadd[0].disabled = true;
				this.fromdataadd[0].inputdata = row.InvClass;
				
				// 经销商取消禁用，以便重新选择修改
				this.fromdataadd[1].disabled = false;
				this.fromdataadd[1].inputdata = row.CreateOrg;
				this.fromdataadd[1].options = [{
					key: row.CreateOrg,
					value: row.CreateOrgName
				}];
				
				// 盘点名称、盘点备注
				this.fromdataadd[2].inputdata = row.CVTitle || '';
				this.fromdataadd[3].inputdata = row.Remark || '';
				
				if (this.cusCode) {
					this.fromdataadd[1].hidden = true;
					this.fromdataadd[2].hidden = true;
					this.fromdataadd[3].hidden = true;
				}
				
				this.dialogVisible = true;
			},
			//经销商列表
			async getCustomerList(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.fromdataadd[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.fromdataadd[1].options.push(obj)
					})
				}
			},
			remoteMethod(param) {
				this.getCustomerList(param);
			},
			cancel() {
				this.dialogVisible = false
			},
			async dialogOK() {
				if (this.dialogType === 'edit') {
					let params = {
						CVMID: this.selectIds[0].CVMID
					};
					if (this.$refs.adds[1] && this.$refs.adds[1].modelvalue !== undefined) {
						params.CreateOrg = this.$refs.adds[1].modelvalue;
					}
					if (this.$refs.adds[2] && this.$refs.adds[2].modelvalue !== undefined) {
						params.CVTitle = this.$refs.adds[2].modelvalue;
					}
					if (this.$refs.adds[3] && this.$refs.adds[3].modelvalue !== undefined) {
						params.Remark = this.$refs.adds[3].modelvalue;
					}
					let {
						code,
						data,
						message
					} = await EditCheckVouchTitle(params);
					if (code == 0) {
						this.handSearch();
						this.$message.success('修改成功');
						this.dialogVisible = false;
					} else {
						this.$message.warning(message);
					}
				} else {
					let params = {
						InvClass: this.$refs.adds[0].modelvalue
					}

					if (this.$refs.adds[1] && this.$refs.adds[1].modelvalue) {
						params.CreateOrg = this.$refs.adds[1].modelvalue
					}
					if (this.$refs.adds[2] && this.$refs.adds[2].modelvalue) {
						params.CvTitle = this.$refs.adds[2].modelvalue
					}
					if (this.$refs.adds[3] && this.$refs.adds[3].modelvalue) {
						params.Remark = this.$refs.adds[3].modelvalue
					}
					let {
						code,
						data,
						message
					} = await AddScanCheckVouch(params);
					if (code == 0) {
						this.handSearch();
						this.$message.success('新增成功');
						this.dialogVisible = false;
					} else {
						this.$message.warning(message);
					}
				}
			},
			handleCurrentChange2(e) {
				this.query2.pageIndex = e
				this.getDetail();
			},
			handleSizeChange2(e) {
				this.query2.pageSize = e
				this.getDetail();
			},
			handSearch2() {
				this.query2.pageIndex = 1;
				this.getDetail();
			},
			handReset2() {
				this.query2 = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArrs.map((item, index) => {
					item.modelvalue = '';
				})
				this.getDetail();
			},
			handleDel() {
				const row = this.getSingleSelectedRow('删除');
				if (!row) return;
				this.tableCurr = row;
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = await DeleteCheckVouch({
						CVMID: row.CVMID,
					}, '')
					loading.close();
					if (res.code == 0) {
						this.getData();
						this.$message.success('操作成功');
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {});
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 155px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 21px;
		}
	}

	.ContentView_CheckVouch {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 0px;
		}

		.ativte {
			border: 1px solid red;
			color: #e71d43;
			background-color: #fce8ec;
			transition: 0.2s linear;
		}

		.incenters {
			padding: 14px 4px;

			div {
				margin-left: 8px;
				margin-right: 8px;
				margin-top: 5px;
				margin-bottom: 5px;
				// width: 100%;
			}
		}

		.topstate {
			width: 100px;
			height: 32px;
			font-size: 14px;
			border: 1px solid #e6e6e6;
			line-height: 32px;
			text-align: center;
			cursor: pointer;
			display: inline-block;
			user-select: none;
		}

		.custom-table {
			padding: 0px 0px 24px 0px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;

				.cell {
					.update_ipt {
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border-radius: 0px;
						}

						.el-input__inner:focus {
							border-color: #e71d43;
						}
					}

					.table-export {
						color: #e71d43;
						cursor: pointer;
						margin-right: 8px;
					}
					.table-export:last-child{
						margin-right: 0px;
					}
				}
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}

			// /deep/.el-table__body {
			// 	td {
			// 		padding: 0px 0 !important;
			// 		cursor: pointer;
			// 	}
			// }
		}

	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}


	.chat-container {
		padding: 20px;
		height: 500px;
		overflow-y: auto;
	}

	.message {
		display: flex;
		margin-bottom: 20px;

		&.lefts {
			justify-content: flex-start;

			.content-box {
				margin-left: 15px;
			}

			.bubble {
				background: #fff;
				border-radius: 0 12px 12px 12px;

				&::before {
					content: '';
					position: absolute;
					left: -10px;
					top: 0;
					border: 6px solid transparent;
					border-right-color: #fff;
				}
			}
		}

		&.rights {
			justify-content: flex-end;

			.content-box {
				margin-right: 15px;
				align-items: flex-end;
			}

			.bubble {
				background: #95ec69;
				border-radius: 12px 0 12px 12px;

				&::before {
					content: '';
					position: absolute;
					right: -10px;
					top: 0;
					border: 6px solid transparent;
					border-left-color: #95ec69;
				}
			}
		}
	}

	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		object-fit: cover;
	}

	.content-box {
		max-width: 60%;
		display: flex;
		flex-direction: column;
	}

	.info {
		margin-bottom: 5px;

		.nickname {
			font-size: 12px;
			color: #666;
			margin-right: 8px;
		}

		.time {
			font-size: 10px;
			color: #999;
		}
	}

	.bubble {
		position: relative;
		padding: 12px;
		font-size: 14px;
		line-height: 1.5;
		color: #333;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
</style>
